import { OrderVariant } from "@models/OrderVariant";

export default function getOrderVariantComplianceStatus(
  orderVariant: OrderVariant
): "denied" | "pending" | "ok" {
  // this only checks item-type triggered-rules
  if (orderVariant.priorApprovalDenied) {
    return "denied";
  }

  if (orderVariant.overridesCompliance) {
    return "ok";
  }

  const allRules = [
    ...orderVariant.priorApprovalTriggeredRules,
    ...orderVariant.triggeredRules,
  ];
  let hasPendingRules = false;

  for (const rule of allRules) {
    if (rule.status === "denied" || rule.status === "in-violation") {
      return "denied";
    }
    if (rule.status !== "approved") {
      hasPendingRules = true;
    }
  }

  return hasPendingRules ? "pending" : "ok";
}
